/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 0.0.12
 */

export type ReportsFindCoordinatesSpecie =
  (typeof ReportsFindCoordinatesSpecie)[keyof typeof ReportsFindCoordinatesSpecie];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportsFindCoordinatesSpecie = {
  canisLupus: 'canisLupus',
  bosTaurus: 'bosTaurus',
  susScrofa: 'susScrofa',
  anasPlatyrhynchos: 'anasPlatyrhynchos',
  apisMellifera: 'apisMellifera',
} as const;
